import { GetterTree } from 'vuex'
import { State } from '@/store/modules/synthetics/secretManager/secretManager.store';

const getters: GetterTree<State, State> = {
    getSearchSecretName: state => {
        return state.searchSecretName;
    },
    getSecretId: state => {
        return state.secretId;
    },
    getSecretName: state => {
        return state.secretName;
    },
    getIsSecretDeleteActive: state => {
        return state.isSecretDeleteActive;
    },
    getSecretPageNum: state => {
        return state.secretPageNum;
    },
    getSecretSortParams: state => {
        return state.secretSortParams;
    },
    getIsSecretFormOpen: state => {
        return state.isSecretFormOpen;
    }
}

export default getters;